// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1mYhc","approved":"Status_approved__2K0CR","rejected":"Status_rejected__1xWGH","expired":"Status_expired__37qVZ","label":"Status_label__2FYpJ"};